module.exports = __webpack_public_path__ + "img/Wave.296eb358.jpg";